import LDClient, { LDClient as LDClientType, LDContext, LDOptions } from 'launchdarkly-js-client-sdk';

export const LD_INIT_TIMEOUT_SECONDS = 5;
export const LD_INIT_RETRY_TIMEOUT_SECONDS = 2;
export const LD_INIT_MAX_ATTEMPTS = 3;
export const LD_INIT_FAILED = 'launchdarkly-init-failed';

export async function initializeLDClientWithRetry(
  clientSideId: string,
  context: LDContext,
  options?: LDOptions,
  maxAttempts: number = LD_INIT_MAX_ATTEMPTS,
): Promise<LDClientType> {
  let lastError: unknown;
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    const client = LDClient.initialize(clientSideId, context, options);
    try {
      await client.waitForInitialization(attempt === 1 ? LD_INIT_TIMEOUT_SECONDS : LD_INIT_RETRY_TIMEOUT_SECONDS);
      return client;
    } catch (err) {
      lastError = err;
      await Promise.resolve(client.close()).catch(() => undefined);
    }
  }
  throw lastError;
}
